import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rmwj",
  "use": "icon-rmwj-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rmwj\"><path d=\"M96 1024V0h448v384h384v640H96z m416-544a32 32 0 0 0-32-32H192a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h288a32 32 0 0 0 32-32v-96z m352 224a32 32 0 0 0-32-32H192a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-96z\" fill=\"#3CC451\" p-id=\"16561\" /><path d=\"M608 0l320 320H608V0z\" fill=\"#B0E7B8\" p-id=\"16562\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol